var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0C7.3755 0 0 7.3755 0 16.5C0 25.6245 7.3755 33 16.5 33C25.6245 33 33 25.6245 33 16.5C33 7.3755 25.6245 0 16.5 0ZM24.75 22.4235L22.4235 24.75L16.5 18.8265L10.5765 24.75L8.25 22.4235L14.1735 16.5L8.25 10.5765L10.5765 8.25L16.5 14.1735L22.4235 8.25L24.75 10.5765L18.8265 16.5L24.75 22.4235Z",
    fill: "#FF4530"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRedIcon);
export default __webpack_public_path__ + "static/media/CrossRedIcon.4e093218d7e1fd43e67285c20cefff49.svg";
export { ForwardRef as ReactComponent };